import React, { useEffect, useMemo, useState } from 'react';
        import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
        import 'leaflet/dist/leaflet.css';
        import L from 'leaflet';

        // Fix for default markers in React Leaflet
        delete L?.Icon?.Default?.prototype?._getIconUrl;
        L?.Icon?.Default?.mergeOptions({
          iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
          iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
          shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
        });

        const ProductMap = ({ products = [] }) => {
          const [mapCenter, setMapCenter] = useState([39.8283, -98.5795]); // Center of US
          const [isLoading, setIsLoading] = useState(true);
          const productsWithCoordinates = useMemo(
            () =>
              products.filter((product) => {
                const lat = product?.coordinates?.lat;
                const lng = product?.coordinates?.lng;
                return Number.isFinite(lat) && Number.isFinite(lng);
              }),
            [products],
          );

          useEffect(() => {
            if (productsWithCoordinates.length > 0) {
              // Calculate center based on product locations
              const avgLat = productsWithCoordinates.reduce(
                (sum, product) => sum + product.coordinates.lat,
                0,
              ) / productsWithCoordinates.length;
              const avgLng = productsWithCoordinates.reduce(
                (sum, product) => sum + product.coordinates.lng,
                0,
              ) / productsWithCoordinates.length;
              setMapCenter([avgLat, avgLng]);
            }
            setIsLoading(false);
          }, [productsWithCoordinates]);

          if (isLoading) {
            return (
              <div className="h-96 bg-secondary-100 rounded-lg flex items-center justify-center">
                <div className="text-center">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2"></div>
                  <p className="text-sm text-text-secondary">Loading map...</p>
                </div>
              </div>
            );
          }

          return (
            <div className="relative h-96 rounded-lg overflow-hidden border border-border">
              <MapContainer
                center={mapCenter}
                zoom={6}
                style={{ height: '100%', width: '100%' }}
                scrollWheelZoom={false}
              >
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {productsWithCoordinates.map((product) => (
                  product?.coordinates && (
                    <Marker
                      key={product?.id}
                      position={[product?.coordinates?.lat, product?.coordinates?.lng]}
                    >
                      <Popup>
                        <div className="p-2">
                          <h3 className="font-semibold text-sm">{product?.title}</h3>
                          <p className="text-xs text-text-secondary">{product?.location}</p>
                          <p className="text-sm font-medium text-primary">${product?.price} {product?.priceUnit}</p>
                        </div>
                      </Popup>
                    </Marker>
                  )
                ))}
              </MapContainer>
              {productsWithCoordinates.length === 0 && (
                <div className="absolute inset-0 bg-surface/80 flex items-center justify-center p-4">
                  <div className="text-center">
                    <p className="text-sm font-medium text-text-primary mb-1">
                      Harita konumu bulunamadı
                    </p>
                    <p className="text-xs text-text-secondary">
                      Ürünlerde koordinat bilgisi olmadığı için haritada gösterilemiyor.
                    </p>
                  </div>
                </div>
              )}
            </div>
          );
        };

        export default ProductMap;
